module.exports = __webpack_public_path__ + "static/media/ya.01e51e10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ya.jpg
// module id = 212
// module chunks = 0